import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRAND_RESTORE_RESOURCE = "brand" as const;
export const BRAND_RESTORE_API_PATH = `/v1/${BRAND_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type BrandRestoreResponse =
  paths[typeof BRAND_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useBrandRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BrandRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<BrandRestoreResponse>(
        `/v1/${BRAND_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRAND_RESTORE_RESOURCE],
      });
    },
  });
};
